

import { Injectable } from '@angular/core'; // Fix: Must be @angular/core
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Permission {
      id?: string;
      code: string;
      name: string;
      isAssigned?: boolean;
}

export interface Organisation {
      id: string;
      name: string;
}

export interface OrgRole {
      id: string;
      orgId: string;
      name: string;
      code: string;
      orgName: string;
}

@Injectable({ providedIn: 'root' })
export class PermissionService {
      private apiUrl = `${environment.apiUrl}/api/Permission`;

      constructor(private http: HttpClient) { }

      // --- Core Data Fetching ---

      getOrganisations(): Observable<Organisation[]> {
            return this.http.get<Organisation[]>(`${this.apiUrl}/organisations`);
      }

      getAllRoles(): Observable<OrgRole[]> {
            return this.http.get<OrgRole[]>(`${this.apiUrl}/all-with-org`);
      }

      getAll(): Observable<Permission[]> {
            return this.http.get<Permission[]>(this.apiUrl);
      }

      // --- Mapping Logic ---

      getByRole(roleId: string): Observable<Permission[]> {
            return this.http.get<Permission[]>(`${this.apiUrl}/role/${roleId}`);
      }

      assign(dto: any): Observable<boolean> {
            return this.http.post<boolean>(`${this.apiUrl}/assign-to-role`, dto);
      }

      // --- CRUD Operations (Fix: Added missing create method) ---

      create(dto: Permission): Observable<string> {
            return this.http.post<string>(this.apiUrl, dto);
      }

      update(dto: Permission): Observable<boolean> {
            return this.http.put<boolean>(this.apiUrl, dto);
      }

      delete(id: string): Observable<boolean> {
            return this.http.delete<boolean>(`${this.apiUrl}/${id}`);
      }
}